import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import FormikInput from "components/formikInput";
import { Form, Formik } from "formik";
import React from "react";
import { CourseModule } from "slices/courseSlice";
import Button from "themeComponents/Button";
import Typography from "themeComponents/Typography";

interface Module extends CourseModule {
  content: any[];
}

interface ModuleDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: Partial<Module>) => void;
  module: Module | null;
}

export function ModuleDialog({ open, onClose, onSave, module }: ModuleDialogProps): React.JSX.Element {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{module ? "Edit Module" : "Add Module"}</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={{
            title: module?.title || "",
            description: module?.description || "",
            unlockCondition: module?.unlockCondition || "sequential",
            isUnlocked: module?.isUnlocked ?? true,
          }}
          onSubmit={(values) => {
            onSave(values);
            onClose();
          }}
        >
          {({ submitForm }) => (
            <Form>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12}>
                  <FormikInput
                    name="title"
                    label="Module Title *"
                    placeholder="e.g., Introduction to React Components"
                    size="large"
                  />
                  <Typography variant="caption" color="text" mt={0.5} display="block">
                    Enter a clear and descriptive title for this module
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <FormikInput
                    name="description"
                    label="Module Description"
                    placeholder="Describe what students will learn in this module..."
                    multiline
                    rows={3}
                    size="large"
                  />
                  <Typography variant="caption" color="text" mt={0.5} display="block">
                    Optional: Provide a detailed description of the module content
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <FormikInput
                    name="unlockCondition"
                    type="dropdown"
                    label="Unlock Condition *"
                    options={[
                      { value: "sequential", label: "Sequential (unlocks after previous module)" },
                      { value: "assessment_passed", label: "Assessment Passed (requires passing assessment)" },
                    ]}
                    size="large"
                  />
                  <Typography variant="caption" color="text" mt={0.5} display="block">
                    Module availability is resolved from assessments via moduleID and unlocksModuleID
                  </Typography>
                </Grid>
              </Grid>
              <DialogActions sx={{ mt: 2 }}>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={submitForm} variant="gradient" color="info">
                  Save
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}

